import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';

export interface Survey {
  id: number;
  title: string
  embedCode: string;
  date: Date;
  expiry: Date;
}

export class SurveyService extends AuthenticatedService {
  public list = async (page: number = 1): Promise<IHttpResponse<Page<Survey>>> => {
    const surveys = await this.getAuth<Page<Survey>>(
      `surveys?page=${page}`,
    );

    return surveys;
  }

  public latest = async (): Promise<IHttpResponse<Survey>> => {
    const survey = await this.getAuth<Survey>(
      'surveys/latest',
    );

    return survey;
  }

  public byId = async (id: number): Promise<IHttpResponse<Survey>> => {
    const survey = await this.getAuth<Survey>(
      `surveys/${id}`,
    );

    return survey;
  }

  public create = async (survey: Survey): Promise<IHttpResponse<Survey>> => {
    const newSurvey = await this.postAuth<Survey>(
      'surveys', survey,
    );

    return newSurvey;
  }

  public update = async (survey: Survey): Promise<IHttpResponse<Survey>> => {
    const newSurvey = await this.putAuth<Survey>(
      `surveys/${survey.id}`, survey,
    );

    return newSurvey;
  }

  public remove = async (id: number): Promise<IHttpResponse<Survey>> => {
    const newSurvey = await this.deleteAuth<Survey>(
      `surveys/${id}`,
    );

    return newSurvey;
  }
}
